var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMute = function SvgMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7a1 1 0 0 1 1-1h3l4.36-3.633a1 1 0 0 1 1.64.768v13.73a1 1 0 0 1-1.64.768L5 14H2a1 1 0 0 1-1-1V7ZM15.75 11.414l1.44 1.44a.5.5 0 0 0 .706 0l.708-.707a.5.5 0 0 0 0-.708L17.164 10l1.44-1.44a.5.5 0 0 0 0-.706l-.707-.707a.5.5 0 0 0-.708 0L15.75 8.586l-1.44-1.44a.5.5 0 0 0-.706 0l-.707.708a.5.5 0 0 0 0 .707L14.335 10l-1.44 1.438a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.44-1.44Z"
  })));
};
export default SvgMute;